import type { AxiosInstance, AxiosError } from 'axios'

import type { TokensManager } from '@/core/auth/TokensManager'

declare module 'axios' {
  interface AxiosRequestConfig {
    retry?: true
  }
}

export default class Api {
  constructor(
    private readonly client: AxiosInstance,
    private readonly manager: TokensManager
  ) {
    this.client.interceptors.request.use((config) => {
      if (this.manager.token === undefined) {
        return config
      }

      const newConfig = {
        headers: {},
        ...config,
      }

      newConfig.headers.Authorization = `Bearer ${this.manager.token}`

      return newConfig
    })

    this.client.interceptors.response.use(
      (r) => r,
      async (error: AxiosError) => {
        if (
          this.manager.refreshToken === undefined ||
          error.response === undefined ||
          error.response.status !== 401 ||
          error.config.retry
        ) {
          throw error
        }

        const token = await this.manager.refresh()

        if (token === undefined) {
          this.manager.clear()
          return
        }

        const config = {
          ...error.config,
          retry: true,
        } as const

        return this.client(config)
      }
    )
  }
}
